import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { LeadFilter } from '../filter';
import { LeadSearch } from '../lead-search';
import { LeadSearchView } from '../lead-search-view';
import { LeadSearchTotal } from '../lead-search-total';

@Injectable({
    providedIn: 'root'
})
export class LeadSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/lead`;
    }

    /** Realiza a pesquisa do Search View dos leads */
    searchView(filter: LeadFilter, orderBy: number, orderByDir: string): Observable<LeadSearchView> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        return this.customHttp.get<LeadSearchView>(`${this.pathApi}/0/view`, {params});
    }

    /** Realizada a pesquisa os leads */
    search(filter: LeadFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<LeadSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<LeadSearch[]>(this.pathApi, {params});
    }

    /** Pesquisa um único lead através do ID informado */
    searchOne(idLead: number): Observable<LeadSearch> {
        return this.customHttp.get<LeadSearch>(`${this.pathApi}/${idLead}/search`);
    }

    /** Obtem os totais da pesquisa dos leads cadastrados */
    getTotais(filter: LeadFilter): Observable<LeadSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<LeadSearchTotal>(`${this.pathApi}/0/total`, {params});
    }
}
